import { render } from "./count.vue?vue&type=template&id=34d8f4d7"
import script from "./count.vue?vue&type=script&lang=js"
export * from "./count.vue?vue&type=script&lang=js"

import "./count.vue?vue&type=style&index=0&id=34d8f4d7&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/classic/detail-info-header/count.vue'],['render',render],['__file',"count.vue"]])

export default __exports__